import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BuyerManagePaymentMethodsService {

    constructor(private _http: HttpClient) { }

    savedcards(data){
        return this._http.post(environment.api_url+'buyer/cards',data);
    }

    setdefault(data){
        return this._http.post(environment.api_url+'buyer/card/setdefault',data);
    }

    removecard(data){
        return this._http.post(environment.api_url+'buyer/card/remove',data);
    }

}
